import React from 'react';
import Typography from '@material-ui/core/Typography';
import clsx from 'clsx';
import { SENDER_TYPE } from 'features/ai-assistant/constants';

import { useMessageStyles } from './Message.styled';
import { MessageSkeleton } from './MessageSkeleton';

export const Message = ({
  message: messageData,
  messageFullWidth,
  metaDataComponent: MetaDataComponent
}) => {
  const classes = useMessageStyles({ messageFullWidth });
  const { message, senderType, isDraft, isLatestAssistant } = messageData;
  const isOutbound = senderType === SENDER_TYPE.user;

  if (isDraft) {
    return (
      <div className={clsx(classes.messageRow, classes.messageRowInbound)}>
        <div className={clsx(classes.responseContainer, classes.responseContainerLatest)}>
          <MessageSkeleton />
        </div>
      </div>
    );
  }

  return (
    <div
      className={clsx(
        classes.messageRow,
        isOutbound ? classes.messageRowOutbound : classes.messageRowInbound
      )}
    >
      {isOutbound ? (
        <div className={classes.messageBubble}>
          <Typography variant="body1" className={classes.messageText}>
            {message}
          </Typography>
        </div>
      ) : (
        <div
          className={clsx(classes.responseContainer, {
            [classes.responseContainerLatest]: isLatestAssistant
          })}
        >
          <Typography
            className={classes.assistantTypography}
            component="div"
            variant="body1"
            dangerouslySetInnerHTML={{ __html: message }}
          />
          {MetaDataComponent && <MetaDataComponent data={messageData} />}
        </div>
      )}
    </div>
  );
};
